<template>
    <div class="hello">

        <!--hello form home components
        <ul >
            <li><router-link to="/auto/contract/2673545/2125112">Go to contract</router-link></li>
            <li><router-link to="/auto/monitoringform">Go to monitoring</router-link></li>
            <li><router-link to="/auto/ContractPreview/2673545/2125112">Go to ContractPreview</router-link></li>
        </ul>-->
    </div>
</template>

<script>
    export default {
        name: 'HelloWorld',

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>
